import React from 'react';

const ServicesIndustrial: React.FC = () => {
  const services = [
    {
      id: 'rental',
      icon: '▦',
      title: 'ALQUILER DE UNIDADES',
      description: 'Flota completa de unidades sanitarias portátiles de grado industrial. Disponibilidad inmediata y mantenimiento incluido.',
      specs: ['Unidades estándar', 'Unidades premium', 'Unidades accesibles', 'Instalación incluida']
    },
    {
      id: 'maintenance',
      icon: '◈',
      title: 'MANTENIMIENTO ESPECIALIZADO',
      description: 'Servicio técnico profesional con protocolos de higiene industrial. Monitoreo continuo y respuesta inmediata.',
      specs: ['Limpieza profunda', 'Desinfección certificada', 'Reposición de insumos', 'Monitoreo 24/7']
    },
    {
      id: 'operators',
      icon: '◐',
      title: 'OPERARIOS CERTIFICADOS',
      description: 'Personal técnico altamente capacitado con turnos flexibles. Cobertura completa durante todo el evento.',
      specs: ['Turnos de 8 horas', 'Turnos de 12 horas', 'Personal certificado', 'Supervisión técnica']
    },
    {
      id: 'supplies',
      icon: '◇',
      title: 'INSUMOS BIODEGRADABLES',
      description: 'Productos eco-friendly de grado industrial. Cumplimiento normativo ambiental garantizado.',
      specs: ['Papel higiénico eco', 'Desinfectantes bio', 'Jabones orgánicos', 'Certificación ambiental']
    }
  ];

  return (
    <section id="servicios" className="section-industrial services-industrial">
      <div className="services-container">
        <div className="grid-industrial grid-industrial-2">
          {services.map((service) => (
            <div key={service.id} className="service-card-industrial">
              <div className="service-icon-industrial">
                <span className="service-icon-symbol">{service.icon}</span>
              </div>
              
              <h3 className="service-title-industrial">{service.title}</h3>
              
              <p className="service-description-industrial">{service.description}</p>
              
              <div className="service-specs" style={{ marginTop: '24px' }}>
                <ul style={{ 
                  listStyle: 'none',
                  display: 'grid',
                  gap: '8px'
                }}>
                  {service.specs.map((spec, index) => (
                    <li key={index} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      fontSize: '0.875rem',
                      color: 'var(--industrial-metallic)'
                    }}>
                      <span style={{ 
                        color: 'var(--industrial-primary)',
                        fontWeight: 'bold'
                      }}>▸</span>
                      {spec}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div style={{ marginTop: '24px', paddingTop: '24px', borderTop: '1px solid var(--industrial-border)' }}>
                <a href="#contacto" className="btn-industrial btn-industrial-outline" style={{ width: '100%', justifyContent: 'center' }}>
                  <span>◉</span>
                  <span>SOLICITAR INFO</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesIndustrial;